export default "__VITE_ASSET__d3c21835__"